import { PanelComponent } from '../components/panel/panel.component';
import { Controls } from '../helpers';
import { Question } from './question';
import { Page } from './page';
import { FormEngineComponent } from '../typing/form-engine-component';
import { QuestionSchema, PanelSchema, DynamicComponent } from '../abstractions';
import { ElementManager } from './element-manager';

export class Panel
  extends ElementManager<Question, Page, PanelSchema>
  implements DynamicComponent<PanelComponent>
{
  component!: FormEngineComponent<PanelComponent>;
  type: Controls;

  constructor(schema: PanelSchema, parent: Page) {
    super(schema, parent);
    this.type = Controls.Panel;
  }

  addSchemaElement(element: QuestionSchema): void {
    const question = new Question(element, this);
    const previousNode: Question | null =
      this.elements.length > 1 ? this.elements[this.elements.length - 1] : null;
    if (previousNode) {
      question.setPrevious(previousNode);
    }
    this.elements.push(question);
    this.component.instance.factory.generateView(question);
  }
}
